<!-- Output Settings Format Editor -->
<div>
  <div class="form-group-panel">
    <form [formGroup]="form">
      <h4>
        {{ "widget-settings-general.group.export-layout-settings" | translate }}
      </h4>
      <sui-checkbox formControlName="settings.section_break_page_break_before">
        {{ "widget.settings-output.label.page-break-before" | translate }}
      </sui-checkbox>
    </form>
  </div>
  <div class="export-formats form-group-panel">
    <form [formGroup]="form">
      <h4>
        {{
          "widget-settings-output-settings.enable-export-in-formats" | translate
        }}
      </h4>
      @for (format of exportFormats; track format) {
        <div>
          <sui-checkbox
            [ngModel]="selectedFormats.includes(format.value)"
            [ngModelOptions]="{ standalone: true }"
            (checkedChange)="onCheckboxChange($event, format.value)"
          >
            {{ format.name }}
          </sui-checkbox>
        </div>
      }
    </form>
  </div>
  <!-- Override Behavior Radio Group -->
  @if (hasOutputSettings) {
    <div
      class="form-group-panel"
      sui-radio-group
      [ngModel]="overrideOutputSettings"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onOverrideSettingsChange($event)"
      orientation="vertical"
    >
      <sui-radio [value]="false">
        {{
          "widget-settings-output-settings.radio-label.use-current-output-settings"
            | translate
        }}
      </sui-radio>
      <sui-radio [value]="true">
        {{
          "widget-settings-output-settings.radio-label.override-output-settings"
            | translate
        }}
      </sui-radio>
    </div>
  }

  @if (hasOutputSettings && hasMultipleFormats) {
    <div class="widget-format-tabs">
      <sui-tabs
        [tabs]="tabItems"
        [value]="activeTabValue"
        (valueChange)="onTabChange($event)"
      ></sui-tabs>
    </div>
  }

  <!-- Format Editor Content -->
  @if (
    hasOutputSettings && !isLoading && outputSettings && getCurrentFormGroup()
  ) {
    <div class="widget-format-content">
      <app-output-settings-format-editor
        [outputSettings]="outputSettings"
        [outputFormatId]="selectedFormatId"
        [formGroup]="getCurrentFormGroup()"
        [showComponents]="false"
        [showProperties]="true"
        [showSettings]="true"
        [showInternalTabs]="false"
        [useWidgetLayout]="true"
        [numberOfColumns]="3"
        [fieldsDisabled]="!overrideOutputSettings"
      ></app-output-settings-format-editor>
    </div>
  }
</div>

@if (!isLoading && !outputSettings) {
  <sui-empty-state
    [title]="
      'widget-settings-output-settings.no-settings-available' | translate
    "
  ></sui-empty-state>
}
